"use strict";
import { Fragment, jsx } from "react/jsx-runtime";
import { Fragment as Fragment2, useContext, useMemo } from "react";
import { ShellContext } from "../context";
import { useOwnerModule } from "../hooks";
export function useContentChannel(...args) {
  let moduleId;
  let channelId;
  const ownerModule = useOwnerModule();
  if (args.length === 1) {
    moduleId = ownerModule ? ownerModule.id : null;
    channelId = args[0];
  } else {
    moduleId = args[0];
    channelId = args[1];
  }
  const { getChannelSubscriptions } = useContext(ShellContext);
  const channelSubscriptions = useMemo(() => {
    return getChannelSubscriptions(moduleId, channelId).filter(
      (subscription) => subscription.type === "component"
    );
  }, [getChannelSubscriptions, moduleId, channelId]);
  return channelSubscriptions;
}
export const ContentChannel = (props) => {
  const { id, children } = props;
  const channelSubscriptions = useContentChannel(id);
  const length = channelSubscriptions.length;
  return /* @__PURE__ */ jsx(Fragment, { children: channelSubscriptions.map((subscription, index) => {
    if (subscription.type !== "component") return null;
    const { module, component: Component, params } = subscription;
    const child = children ? children(/* @__PURE__ */ jsx(Component, {}), index, length, module, params) : /* @__PURE__ */ jsx(Component, {});
    if (child === null) return null;
    return /* @__PURE__ */ jsx(Fragment2, { children: child }, index);
  }) });
};
